const Spotify_Cards_Webhost = 'cards.promocards.io';

export default Spotify_Cards_Webhost;
